import { useEffect } from 'react';

import { conversionPoints } from '@/components/Modals/context/ModalRoutingContext';
import { getConversion, recordConversion } from '@/utils/analytics/conversion';

import type { ModalConversionPoints } from '@/components/Modals/shared-types';

// Registers a fallback conversion point when no upstream CTA has already set
// one, so purchase events from in-app upgrade flows are always attributed.
export function useEnsureModalConversionPoint(point: ModalConversionPoints) {
  useEffect(() => {
    const { conversion_source } = getConversion();
    if (!conversion_source) {
      recordConversion({ source: conversionPoints[point] });
    }
  }, [point]);
}
